export default "__VITE_ASSET__0c181186__"